import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './css/Badge.scss';
import classNames from 'classnames';

export default class Badge extends Component {
    static propTypes = {
        block: PropTypes.bool,
        children: PropTypes.node,
        className: PropTypes.string,
        link: PropTypes.bool,
        emphasis: PropTypes.oneOf(['default', 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light']),
        size: PropTypes.oneOf(['small']),
    }

    static defaultProps = {
        block: false,
        link: false,
        emphasis: 'default',
    }

    render() {
        const {className, block, emphasis, children, link, size, ...props} = this.props;

        const classes = classNames(className, styles.badge, styles[emphasis], styles[size], {
            [styles.block]: block,
        });

        return React.createElement(
            link ? 'a' : 'div',
            Object.assign({}, props, {className: classes}),
            [
                children,
            ].map((v, k) => {
                if (v === null) {
                    return null;
                }
                return <span key={k}>{v}</span>;
            })
        );
    }
}
